import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface UsageGuideButtonProps {
  onClick: () => void;
}

export const UsageGuideButton = ({ onClick }: UsageGuideButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      aria-label={t('usageGuide.buttonLabel')}
      onClick={onClick}
      cursor="pointer"
      borderRadius="lg"
      border="2px solid"
      borderColor="borders.default"
      bg="white"
      px={{ base: 2, md: 4 }}
      py={2}
      fontSize={{ base: 'xs', md: 'sm' }}
      color="text.primary"
      boxShadow="md"
      transition="all 0.2s"
      _hover={{ bg: 'primaryLight', color: 'primary' }}
    >
      {t('usageGuide.buttonLabel')}
    </Button>
  );
};
